import _styled from "@emotion/styled/base";
import { colors, lengths } from 'decap-cms-ui-default';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const StyledCode = /*#__PURE__*/_styled("code", {
  target: "ep5r8zv0",
  label: "StyledCode"
})("background-color:", colors.background, ";border-radius:", lengths.borderRadius, ";padding:0 2px;font-size:85%;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9SaWNodGV4dENvbnRyb2wvY29tcG9uZW50cy9MZWFmL0NvZGVMZWFmLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUc4QiIsImZpbGUiOiIuLi8uLi8uLi8uLi8uLi9zcmMvUmljaHRleHRDb250cm9sL2NvbXBvbmVudHMvTGVhZi9Db2RlTGVhZi5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGNvbG9ycywgbGVuZ3RocyB9IGZyb20gJ2RlY2FwLWNtcy11aS1kZWZhdWx0JztcblxuY29uc3QgU3R5bGVkQ29kZSA9IHN0eWxlZC5jb2RlYFxuICBiYWNrZ3JvdW5kLWNvbG9yOiAke2NvbG9ycy5iYWNrZ3JvdW5kfTtcbiAgYm9yZGVyLXJhZGl1czogJHtsZW5ndGhzLmJvcmRlclJhZGl1c307XG4gIHBhZGRpbmc6IDAgMnB4O1xuICBmb250LXNpemU6IDg1JTtcbmA7XG5cbmZ1bmN0aW9uIENvZGVMZWFmKHsgY2hpbGRyZW4sIC4uLnByb3BzIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8U3R5bGVkQ29kZSBhc0NoaWxkIHsuLi5wcm9wc30+XG4gICAgICB7Y2hpbGRyZW59XG4gICAgPC9TdHlsZWRDb2RlPlxuICApO1xufVxuXG5leHBvcnQgZGVmYXVsdCBDb2RlTGVhZjtcbiJdfQ== */"));
function CodeLeaf({
  children,
  ...props
}) {
  return _jsx(StyledCode, {
    asChild: true,
    ...props,
    children: children
  });
}
export default CodeLeaf;